var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"candle-show"}},[_c('b-col',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('notification.all')))])]),_vm._v(" "),_c('e-index',{attrs:{"uri":_vm.getUri(),"can-create":false,"name":"notification","mode":"list"},scopedSlots:_vm._u([{key:"list-content",fn:function(ctx){return _c('div',{},[_c('one-notification',{attrs:{"notification":ctx.item}})],1)}}])})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ecc96","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Default/Notifications.vue
// module id = 985
// module chunks = 1